var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoggedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66634 9.00016H2.99967V12.3335H10.9997V1.66683H2.99967V5.00016H1.66634V1.00016C1.66634 0.823352 1.73658 0.653782 1.8616 0.528758C1.98663 0.403734 2.1562 0.333496 2.33301 0.333496H11.6663C11.8432 0.333496 12.0127 0.403734 12.1377 0.528758C12.2628 0.653782 12.333 0.823352 12.333 1.00016V13.0002C12.333 13.177 12.2628 13.3465 12.1377 13.4716C12.0127 13.5966 11.8432 13.6668 11.6663 13.6668H2.33301C2.1562 13.6668 1.98663 13.5966 1.8616 13.4716C1.73658 13.3465 1.66634 13.177 1.66634 13.0002V9.00016ZM5.66634 6.3335V4.3335L8.99967 7.00016L5.66634 9.66683V7.66683H0.333008V6.3335H5.66634Z",
    fill: "#656B7C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggedIcon);
export default __webpack_public_path__ + "static/media/logged-icon.806c275a9322ab2ed687ba1215019684.svg";
export { ForwardRef as ReactComponent };